import axios from "axios";

export const BASE_URL = process.env.REACT_APP_API;

export const instance = axios.create({
  baseURL: BASE_URL,
});

// Interceptor para agregar el token JWT a las peticiones
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expirado o inválido - limpiar sesión
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("current_username");

      // Mensaje de sesión para mostrar en pantalla de login
      localStorage.setItem(
        "auth_warning",
        "Sesion expirada o invalida. Inicia sesion nuevamente."
      );

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
